import { ref, watch, getCurrentScope, onScopeDispose } from 'vue'
import { useGlobalI18n } from '@/composables/useI18n'

interface UseTitleOptions {
  obverseTitleMutation: boolean
}

export function useTitle(
  newTitle: MaybeRef<string | null | undefined> = void 0,
  options: UseTitleOptions = {
    obverseTitleMutation: true,
  },
) {
  const { t } = useGlobalI18n()
  const title = ref(newTitle || document.title || null)
  let observer: MutationObserver | null

  watch(
    () => title.value,
    (newTit, oldTit) => {
      if (newTit && newTit !== oldTit) {
        document.title = t(newTit)
      }
    },
    {
      immediate: true,
    },
  )

  if (options.obverseTitleMutation) {
    observer = new MutationObserver(() => {
      if (title.value !== document.title) {
        title.value = document.title
      }
    })

    observer.observe(document.head.querySelector('title')!, { childList: true })
  }

  const stop = () => {
    if (observer) {
      observer.disconnect()
      observer = null
    }
  }

  if (getCurrentScope()) {
    onScopeDispose(() => {
      stop()
    })
  }

  return {
    title,
    stop,
  }
}
